import { useI18n } from '../../i18n/I18nProvider';
import { ModalDialog } from '../../ui/Dialog';
import { CustomerForm, type SavedCustomer } from './CustomerForm';

/**
 * The buyer form in a centred dialog: the container used by the Today setup checklist
 * (DESIGN_SYSTEM §6a). The form mounts fresh each time the dialog opens.
 */
export function CustomerDialog({
  orgId,
  isOpen,
  onOpenChange,
  partyId,
  onSaved,
}: {
  orgId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  /** Edit this buyer; omitted = create. */
  partyId?: string | null;
  onSaved: (party: SavedCustomer) => void;
}) {
  const { t } = useI18n();
  return (
    <ModalDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={partyId ? t.parties.editTitle : t.parties.newTitle}
      wide
    >
      <CustomerForm
        orgId={orgId}
        partyId={partyId ?? null}
        onSaved={(party) => {
          onSaved(party);
          onOpenChange(false);
        }}
        onCancel={() => onOpenChange(false)}
      />
    </ModalDialog>
  );
}
